import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Params, ViewType } from './jobPostView.type';
import Button from 'components/base/Button';
import { Col, Row, Spinner } from 'react-bootstrap';
import AboutJob from 'components/modules/card/aboutJob/AboutJob';
import { useFindOneJobPostQuery } from 'service/recruiterQuery/recruiterQuery';
import { PostResponse } from '../add/addJobPost.type';
import AdditionalInformation from './additionalInfo/AdditionalInformation';

const titleMap: Record<ViewType, string> = {
  internships: 'View a internship',
  jobs: 'View a job post'
};

const descMap: Record<ViewType, string> = {
  internships: 'Internship details.',
  jobs: 'Job post details.'
};

const goBackPath: Record<ViewType, string> = {
  internships: '/panel/recruitment/careers/internships',
  jobs: '/panel/recruitment/careers/jobs'
};

function JobPostView() {
  const { type = 'jobs', id } = useParams<Params>();
  const { data, isLoading } = useFindOneJobPostQuery(id);

  const breadcrumbItemsMap: Record<ViewType, PageBreadcrumbItem[]> =
    useMemo(() => {
      return {
        internships: [
          {
            label: 'Internship',
            url: '/panel/recruitment/careers/internships'
          },
          {
            label: 'View job post',
            url: `/panel/recruitment/careers/internships/view/${id}`,
            active: true
          }
        ],
        jobs: [
          {
            label: 'Job Post',
            url: '/panel/recruitment/careers/jobs'
          },
          {
            label: 'View job post',
            url: `/panel/recruitment/careers/jobs/view/${id}`,
            active: true
          }
        ]
      };
    }, []);
  return (
    <div>
      <PageBreadcrumb items={breadcrumbItemsMap[type]} />
      <section className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">{titleMap[type]}</h2>
            <h5 className="text-body-tertiary fw-semibold">{descMap[type]}</h5>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <Button variant="phoenix-secondary" as={Link} to={goBackPath[type]}>
              Back
            </Button>
          </div>
        </div>
        <Row>
          {isLoading ? (
            <Col xs={12}>
              <div className="d-flex justify-content-center w-100">
                <Spinner animation="border" role="status" className="me-2">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            </Col>
          ) : (
            <>
              <Col xs={12} xl={9}>
                <AboutJob data={data as PostResponse} />
              </Col>
              <Col xs={12} xl={3}>
                <AdditionalInformation data={data as PostResponse} />
              </Col>
            </>
          )}
        </Row>
      </section>
    </div>
  );
}

export default JobPostView;
